import { render, staticRenderFns } from "./application-details.vue?vue&type=template&id=a42bc5c4"
import script from "./application-details.vue?vue&type=script&lang=js"
export * from "./application-details.vue?vue&type=script&lang=js"
import style0 from "./application-details.vue?vue&type=style&index=0&id=a42bc5c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports